// extracted by mini-css-extract-plugin
export default {"wrapper":"OperationWindowRulesDuplicateForm_wrapper__4AuQu","weekWrapper":"OperationWindowRulesDuplicateForm_weekWrapper__2x+N-"};